import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=d77af352"
import script from "@/controllers/admin/user/Add?vue&type=script&lang=ts&external"
export * from "@/controllers/admin/user/Add?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports